import React, { Component } from 'react';
import { connect } from 'react-redux'
import Loading from '../Loading'
import GridWithForm from '../grid/GridWithForm'
import { eitrofikacijasRobezvertibasSelected, eitrofikacijasRobezvertibasActions } from '../../actions/nitratiActions'
import {
    getTextFilterCfg,
} from '../grid/ColumnHelpers'
import {addUrlQuery} from '../../actions/uiActions'

const getColumns = ({ kodif }) => {
    return [
        {
            dataField: 'ND_WBCategory',
            text: 'ND_WBCategory',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_Type',
            text: 'ND_Type',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_Parameter',
            text: 'ND_Parameter',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_ParameterOther',
            text: 'ND_ParameterOther',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_ParameterUoM',
            text: 'ND_ParameterUoM',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_ParameterUoMOther',
            text: 'ND_ParameterUoMOther',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_SamplingSeason',
            text: 'ND_SamplingSeason',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_SamplingNumber',
            text: 'ND_SamplingNumber',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_SamplingPeriod',
            text: 'ND_SamplingPeriod',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_Metrics',
            text: 'ND_Metrics',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_ThresholdNon',
            text: 'ND_ThresholdNon',
            renderClassName: "bold",
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_ThresholdMaybe',
            text: 'ND_ThresholdMaybe',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_Alignment',
            text: 'ND_Alignment',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_Notes',
            text: 'ND_Notes',
            filterCfg: getTextFilterCfg()
        },
    ]
};

const  getFormFieldCfgs = ({ kodif }) => {

  return [
    {
      name: 'ND_WBCategory',
      type: 'text',
      required: true,
    },
    {
      name: 'ND_Type',
      type: 'text',
      required: true,
    },
    {
      name: 'ND_Parameter',
      type: 'text',
      required: true,
    },
    {
      name: 'ND_ParameterOther',
      type: 'text',
    },
    {
      name: 'ND_ParameterUoM',
      type: 'text',
      required: true,
    },
    {
      name: 'ND_ParameterUoMOther',
      type: 'text',
    },
    {
      name: 'ND_SamplingSeason',
      type: 'text',
      required: true,
    },
    {
      name: 'ND_SamplingNumber',
      type: 'text',
      required: true,
    },
    {
      name: 'ND_SamplingPeriod',
      type: 'text',
    },
    {
      name: 'ND_Metrics',
      type: 'text',
    },
    {
      name: 'ND_ThresholdNon',
      type: 'text',
      required: true,
    },
    {
      name: 'ND_ThresholdMaybe',
      type: 'text',
    },
    {
      name: 'ND_Alignment',
      type: 'text',
    },
    {
      name: 'ND_Notes',
      type: 'text',
    },
  ]};


class EitrofikacijasRobezvertibas extends Component {

    render() {
        const { eitrofikacijasRobezvertibas, kodif } = this.props

        if(!eitrofikacijasRobezvertibas || eitrofikacijasRobezvertibas.loading) {
          return (<Loading/>)
        }

        if (!this.columns) {
            this.columns = getColumns({
                kodif: this.props.kodif
            })
        }

        if(!this.formFieldCfgs){
          this.formFieldCfgs = getFormFieldCfgs({ kodif })
        }

        return (
          <GridWithForm
            {...this.props}
            columns={this.columns}
            formFieldCfgs={this.formFieldCfgs}
            storeObj={this.props.eitrofikacijasRobezvertibas}
            formWidthGuiOption="paris_vkn_form_width"
            metadataFormCfg="eitrofikacijas_robezvertibas"
            tiesibasLabot="NITRATI_LABOT"
          />
        )
    }
}

const mapStateToProps = ({kodif, eitrofikacijasRobezvertibas, location}) => ({kodif, eitrofikacijasRobezvertibas, query: location.query})

export default connect(mapStateToProps, {
  selectedAct : eitrofikacijasRobezvertibasSelected,
  addUrlQuery,
  ...eitrofikacijasRobezvertibasActions
})(EitrofikacijasRobezvertibas)
